import React from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const sentryConfig = window.sentry || {};
const { dsn } = sentryConfig;

const defaultTraceTargets = [
  /^\/(?!\/)/,
  /^https?:\/\/(?:[a-z0-9-]+\.)*(?:g4m\.co\.uk|gear4music\.com)(?::\d+)?(?:\/|$)/i,
];

export function initAppSentry() {
  if (!dsn || Sentry.getClient()) {
    return Boolean(Sentry.getClient());
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: Number(sentryConfig.tracesSampleRate ?? 0.1),
    environment: sentryConfig.environment || window.environment,
    tunnel: sentryConfig.tunnel || '/sentry/tunnel',
    release: sentryConfig.release || undefined,
    sendClientReports: true,
    tracePropagationTargets: sentryConfig.tracePropagationTargets || defaultTraceTargets,
  });

  if (window.user?.id) {
    Sentry.setUser({
      id: window.user.id,
      email: window.user.email || undefined,
    });
  }

  return true;
}

initAppSentry();

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
